import throttle from 'lodash/throttle'
import verge from 'verge'

export default {
	template: `
		<canvas></canvas>
	`,

	props: {
		src: {
			type: String,
			required: true
		}
	},

	data: () => ({
		context: null,
		lastSpriteIndex: 0,
		spriteIndex: 0,
		spritesheetRowCount: 2,
		spritesPerRow: 25,
		throttleSpeed: 100,
		spriteWidth: null,
		spriteHeight: null,
		spritesheet: null,
		elCushion: -(document.documentElement.clientHeight / 25),
		drawingInterval: null
	}),

	methods: {
		update() {
			// Only draw if canvas is in viewport
			if (!verge.inViewport(this.$el, this.elCushion)) {
				return
			}
			// Get cross-browser scrollY
			const scrollY = window.scrollY || document.documentElement.scrollTop
			const lastSpriteIndex = this.spriteIndex

			const rect = verge.rectangle(this.$el, this.elCushion)
			const rectDivision = rect.height / (this.spriteCount - 1)

			const rectPosMap = []

			for (let i = 0; i <= this.spriteCount - 1; i++) {
				rectPosMap[rectPosMap.length] = i * rectDivision
			}

			const getSpriteIndex = (counter = 0) => counter * rectDivision < scrollY ?
				getSpriteIndex(counter + 1) :
				rectPosMap.indexOf((counter > 0 ? counter - 1 : counter) * rectDivision)

			const spriteIndex = getSpriteIndex()

			console.log(spriteIndex)

			// Sprite index found?
			if (spriteIndex === -1) {
				return
			}

			// Don't draw if there is no sprite change
			if (this.lastSpriteIndex === spriteIndex) {
				return
			}

			const difference = spriteIndex - this.lastSpriteIndex
			// True for scrolling down, false for scrolling up
			const direction = difference > 0
			// Number of frames to draw between the old state and the new state
			const frameCount = Math.abs(difference);
			console.log(`old: ${this.lastSpriteIndex}, new: ${spriteIndex}, going ${direction ? 'up' : 'down'} in ${frameCount} frames!`)

			// If currently drawing, stop at where we are and start the new spin from where we were up to
			if (this.drawingInterval) {
				this.stopDrawing()
			}

			const fps = 1000 / 60
			let frameCounter = 1

			this.drawingInterval = window.setInterval(() => {
				this.spriteIndex = direction ? this.lastSpriteIndex + frameCounter : this.lastSpriteIndex - frameCounter;
				this.draw()
				frameCounter++
				if (spriteIndex === this.spriteIndex) {
					this.stopDrawing()
				}
			}, fps)
		},

		draw() {
			console.log(`drawing ${this.spriteIndex}`)
			// Clean the canvas before redraw
			this.context.clearRect(0, 0, this.spriteWidth, this.spriteHeight)
			const onSecondRow = this.spriteIndex >= this.spritesPerRow
			const x = onSecondRow ?
				(this.spriteIndex - this.spritesPerRow) * this.spriteWidth :
				this.spriteIndex * this.spriteWidth
			const y = onSecondRow ?
				this.spriteHeight :
				0
			// Draw sprite
			this.context.drawImage(
				this.spritesheet,
				x,
				y,
				this.spriteWidth,
				this.spriteHeight,
				0,
				0,
				this.spriteWidth,
				this.spriteHeight
			)
		},

		stopDrawing() {
			console.log(`stopped at ${this.spriteIndex}`)
			this.lastSpriteIndex = this.spriteIndex
			window.clearInterval(this.drawingInterval)
		}
	},

	computed: {
		spriteCount() {
			return this.spritesPerRow * this.spritesheetRowCount
		}
	},

	mounted() {
		this.context = this.$el.getContext('2d')
		this.spritesheet = new Image()
		this.spritesheet.src = this.src

		this.spritesheet.addEventListener('load', () => {
			this.spriteWidth = this.spritesheet.naturalWidth / (this.spriteCount / this.spritesheetRowCount)
			this.spriteHeight = this.spritesheet.naturalHeight / this.spritesheetRowCount

			// Set canvas width and height
			this.$el.width = this.spriteWidth
			this.$el.height = this.spriteHeight
			// Draw first sprite
			this.draw()
		})

		const component = this

		window.addEventListener('scroll', throttle(component.update, component.throttleSpeed))
	}
}
